<template>
    <transition v-if="showModal">
        <div
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-70 flex justify-center items-center"
        >
            <div
                class="absolute bg-white border-[1px] rounded-[4px] xl:w-8/12 sm:w-10/12 sm:my-[69px]"
            >
                <div>
                    
                <Heading
                    :title="title"
                    class="xl:p-10 sm:bg-gray-100 sm:text-primary sm:p-5"
                />
                <button class="absolute top-2 right-2 text-white" @click="onCloseModal()">
                    <Icon customClasses="text-white sm:text-primary" name="Fechar" />
                </button>
                <div
                    class="mx-2.5 w-2.5/12 xl:px-12 xl:py-10 px-4 py-4 leading-9"
                >
                    <div
                        class="flex flex-col overflow-y-scroll hidden-scroll-bar sm:max-h-96 xl:max-h-[42vh] gap-y-8 sm:pb-8"
                    >
                        <TitleDescription
                            v-if="text"
                            class="sm:pt-8"
                            titleClasses="xl:text-4xl sm:text-3xl"
                            descriptionClasses="sm:text-sm xl:text-base"
                            :description="text"
                        />
                        <p v-else>
                            Nada para ver aqui
                        </p>
                    </div>

                    <a v-if="buttonText" @click="onCloseModal(true)" :href="callToAction">
                        <Button class="py-0 xl:mt-8"> {{ buttonText }} </Button>
                    </a>
                </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue";
import Button from "@/Components/Button.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import TitleDescription from "@/Components/TitleDescription.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";

export default {
    components: {
        Icon,
        HeadingGuest,
        Button,
        Heading,
        TitleDescription,
        ValidationErrors,
    },

    props: {
        showModal: Boolean,
        notification: Object,
        acceptTerms: {
            type: Object,
            default: {},
        },
    },

    data() {
        return {
            errors: [],
        };
    },
    
    emits: ["closeModal"],

    computed: {
        title() {
            return  this.notification?.title || "Novidades!";
        },
        text() {
            return  this.notification?.text || "";
        },
        buttonText() {
            return  this.notification?.buttonLabel || "";
        },
        callToAction() {
            return  this.notification?.hyperlink || "#";
        },
    },
    methods: {
        onCloseModal(isUsed = false) {
            this.$emit('closeModal', { isUsed });
        },
    },
};
</script>
<style scoped>
.hidden-scroll-bar::-webkit-scrollbar {
    display: none;
}
</style>
